export default "__VITE_ASSET__BexN8X3J__"